export default [
  {
    path: '/invite',
    meta: {
      title: '',
      whiteLis: true,
    },
    component: () =>
      import(/* webpackChunkName: "invite" */ '@/pages/invite/index.vue'),
  },
  {
    path: '/invite/success',
    meta: {
      title: '',
      whiteLis: true,
    },
    component: () =>
      import(/* webpackChunkName: "invite" */ '@/pages/invite/success.vue'),
  },
  {
    path: '/inviteCard/custom',
    meta: {
      title: '',
    },
    component: () =>
      import(
        /* webpackChunkName: "invite" */ '@/pages/invite/customInviteCard/index.vue'
      ),
  },
  {
    path: '/liveTestInvite/beInvited',
    meta: {
      title: '接受邀请',
    },
    component: () =>
      import(
        /* webpackChunkName: "invite" */ '@/pages/liveTestInvite/beInvited'
      ),
  },
]
